import React, {useEffect, useRef, useState} from 'react';
import {Table, Divider, Tag, DatePicker, Select} from 'antd';
import moment from "moment/moment";
import axios from "axios";
import { Switch, Icon } from 'antd';
import {Data} from "iconsax-react";
import {FaRegCalendar} from "react-icons/fa";

const {  RangePicker } = DatePicker;
const { Option } = Select;

const columns = [
    {
        title: 'Titulo',
        dataIndex: 'titulo',
        key: 'titulo',
        render: (text, record )=> {
            return (
                <div className="notificacao">

                    <div >
                        <div className="info">
                            <span className="title">{record.titulo}</span>
                            <span className="description">{record.descricao}</span>
                        </div>
                        <div>
                            <span className="tempo">{tempoDecorrido(record.dt_criado)}</span>
                        </div>

                    </div>
                </div>
            )
        },
        
    },

    {
        title: 'Categoria',
        key: 'tipo',
        dataIndex: 'tipo',
        render: (text,category )=> {
            return (
                <Tag color={category.cor || 'default'}>
                    {text}
                </Tag>
            );
        }
    }
    
];

const tempoDecorrido = (date) => {
    const agora = new Date();
    const criado = new Date(date);
    const diffHoras = Math.floor((agora - criado) / (1000 * 60 * 60));

    if (diffHoras < 1) return "agora";
    if (diffHoras < 24) return `Há ${diffHoras} horas atrás`;

    return moment(date).format('DD MMM YYYY');
};

export default function TabelaNotificacoes ({atualizarMarcarIdsNotificacoesLidas}) {
    const [notificacoes, setNotificacoes] = useState([])
    const [paginaAtual, setPaginaAtual] = useState(1)
    const [total, setTotal] = useState(0)
    
    //Filtros
    const [tudo, setTudo] = useState(true)
    const [datas, setDatas] = useState(null)
    const [categoria, setCategoria] = useState(null)

    const idsParaMarcar = useRef(new Set());

    const getNotificacoes = () =>{
        axios({
            method: "get",
            url: "api/notificacoes/listar",
            params: {
                pagina:paginaAtual,
                tudo: tudo,
                dt_inicio: datas?.[0] || null,
                dt_fim: datas?.[1] || null,
                categoria: categoria
            },
            timeout: 60 * 10 * 1000
        })
            .then(response => {
                setNotificacoes(response.data.dados);
                setTotal(response.data.total);
            })
            .catch(error => {
                if (error.response.status === 401)
                    this.setState({
                        redirect: true,
                        redirectLink: "/login"
                    });
            });
    }
    useEffect(() => {
        getNotificacoes()
    }, [paginaAtual,tudo,datas, categoria]);

    

    useEffect(() => {
        if (notificacoes.length > 0) {
            notificacoes
                .filter(n => !n.lido)
                .forEach(n => idsParaMarcar.current.add(n.id)); // acumula ids
        }
        const ids = [...idsParaMarcar.current];
        atualizarMarcarIdsNotificacoesLidas(ids)
    }, [notificacoes]);
    
    return(
        <div className="tabela-notificacoes">
            <div className="filtros">
                <RangePicker
                    className='data-picker'
                    suffixIcon={<FaRegCalendar />}
                    separator='-'
                    onChange={(dates, dateStrings) => {
                        // dates: [dayjs, dayjs] | null
                        // dateStrings: ['2024-01-01', '2024-01-31']
                        setDatas(dateStrings);
                    }}
                />
                <div className="switch-notificacoes">
                     <span>
                        Categoria: 
                    </span>
                    <Select
                        placeholder="Categoria"
                        style={{ width: 150 }}
                        allowClear={true}
                        onChange={(value) => {setCategoria(value)}}
                    >
                        <Option value="1">Transferência</Option>
                        <Option value="2">Remanejado</Option>
                        <Option value="3">Anulado</Option>
                    </Select>
                </div>
                
                <div className="switch-notificacoes">
                    <span>
                        Notificações: 
                    </span>
                    
                    <Switch
                        checkedChildren="Todas"
                        unCheckedChildren="Não lidas"
                        onChange={(checked) =>  setTudo(checked)}
                        checked={tudo}
                    />
                </div>
                
            </div>
            <Table
                columns={columns}
                dataSource={notificacoes}
                rowKey="id"
                pagination={{
                    pageSize: 5,
                    current: paginaAtual,
                    total:total,
                    onChange: (pagina) => setPaginaAtual(pagina),
                }}

            />
        </div>
        
    );
}